import React from 'react'

import View from '../../../../../../components/pdf/View'
import Separator from '../../../../../../components/pdf/Separator'
import Text from '../../../../../../components/pdf/Text'
import Link from '../../../../../../components/pdf/Link'
import Line from '../../../../../../components/pdf/Line'

const CoverSection = ({ clientName, isContract }) => {
  return (
    <View pageBreakAfter>
      <Text semibold size="h2">
        Proposta Btime | {clientName}
      </Text>
      <Line />
      <Separator weight={15} />

      <Link semibold size="h5" href="#escopo-projeto">
        Escopo do Projeto
      </Link>
      <div style={{ paddingLeft: 15 }}>
        <Link href="#escopo-projeto-1">🙋 Quais são as dores do cliente e como resolveremos elas?</Link>
        <Link href="#escopo-projeto-2">🚀 Em quais processos a btime vai atuar?</Link>
        <Link href="#escopo-projeto-3">🧑‍💻 Quais são as funcionalidades inclusas no seu plano?</Link>
        <Link href="#escopo-projeto-4">
          🧑‍💻 Quais são os serviços extras inclusos no seu plano? (Serviços contratados à parte)
        </Link>
      </div>
      <Separator weight={3} />
      {isContract && (
        <>
          <Link semibold size="h5" href="#equipe-projeto">
            🤝 Equipe do Projeto
          </Link>
          <div style={{ paddingLeft: 15 }}>
            <Link href="#equipe-projeto-1">Ponto Focal da Btime</Link>
            <Link href="#equipe-projeto-2">Ponto Focal - {clientName}</Link>
            <Link href="#equipe-projeto-3">Contato Financeiro - {clientName}</Link>
          </div>
          <Separator weight={3} />
        </>
      )}
      <Link semibold size="h5" href="#resumo-investimento">
        Resumo do Investimento
      </Link>
      <div style={{ paddingLeft: 15 }}>
        <Link href="#resumo-investimento-1">Implantação</Link>
        <Link href="#resumo-investimento-2">Mensalidade</Link>
      </div>
      <Separator weight={3} />

      <Link semibold size="h5" href="#detalhes-implantacao">
        Detalhes da Implantação
      </Link>
      <div style={{ paddingLeft: 15 }}>
        <Link href="#detalhes-implantacao-1">O que é a implantação e como ela funciona?</Link>
        <Link href="#detalhes-implantacao-2">Detalhamento dos valores de implantação</Link>
        <Link href="#detalhes-implantacao-3">Detalhamento dos valores da criação de Documentos Customizados</Link>
        <Link href="#detalhes-implantacao-4">Detalhamento dos valores de Integração</Link>
        <Link href="#detalhes-implantacao-5">Detalhamento dos valores da criação de Dashboards Customizados</Link>
      </div>
      <Separator weight={3} />

      <Link semibold size="h5" href="#detalhes-mensalidade">
        Detalhes da Mensalidade - Plataforma btime
      </Link>
      <div style={{ paddingLeft: 15 }}>
        <Link href="#detalhes-mensalidade-1">O que é a mensalidade e como ela funciona?</Link>
        <Link href="#detalhes-mensalidade-2">Detalhamento do pacote Mensal</Link>
      </div>
      <Separator weight={3} />

      <Link semibold size="h5" href="#detalhes-servicos-extras">
        Detalhes da Mensalidade - Serviços Extras
      </Link>
      <div style={{ paddingLeft: 15 }}>
        <Link href="#detalhes-servicos-extras-1">O que é a mensalidade de serviços extras e como ela funciona?</Link>
        <Link href="#detalhes-servicos-extras-2">Detalhamento do pacote de Geração de Documentos</Link>
        <Link href="#detalhes-servicos-extras-3">Detalhamento do pacote de Sustentação</Link>
      </div>
      <Separator weight={3} />

      <Link semibold size="h5" href="#fluxo-contratacao">
        Fluxo de Contratação
      </Link>
      <Separator weight={3} />

      <Link semibold size="h5" href="#contrato">
        Contrato de prestação de serviços e licença de uso de Software
      </Link>
      <Separator weight={15} />
    </View>
  )
}

export default CoverSection
